module.exports = __webpack_public_path__ + "static/media/1.c03050e9.png";